const setBodyOverflow = (overflow, timeout = 0) =>
  setTimeout(() => (document.body.style.overflowY = overflow), timeout);

export default setBodyOverflow;
